import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "mandae-condicao-valor-carrinho",
  templateUrl: "./valor-carrinho.component.html",
  styleUrls: ["./valor-carrinho.component.scss"],
})
export class CondicaoValorCarrinhoComponent {
  public formulario: FormGroup;

  public erro = false;

  public mensagem = "";

  @Output()
  public condicaoResponse = new EventEmitter();

  @Input()
  public set Data(data) {
    if (data) {
      this.formulario.get("inicial").setValue(data.valorInicial);
      this.formulario.get("final").setValue(data.valorFinal);
    }
  }

  constructor(private formBuilder: FormBuilder) {
    this.formulario = this.formBuilder.group({
      inicial: [null],
      final: [null],
    });
  }

  public mudancaCampo() {
    const inicial = this.formulario.get("inicial").value;
    const final = this.formulario.get("final").value;

    this.erro = false;
    this.mensagem = "";
    this.formulario.get("inicial").setErrors(null);
    this.formulario.get("final").setErrors(null);

    // pelo menos o valor inicial foi preenchido - mesmo que com 0 (zero)
    if (inicial !== null) {
      // se existe valor final, mesmo que com 0 (zero)
      if (final !== null) {
        if (inicial > final) {
          this.formulario.get("inicial").setErrors({ menorQueFinal: true });
          this.formulario.get("final").setErrors({ menorQueFinal: true });
          this.mensagem = "O valor inicial é maior que o final.";
          this.erro = true;

          this.condicaoResponse.emit({
            tipo: "valor",
            error: true,
          });

          return false;
        }

        if (inicial === final) {
          this.formulario.get("inicial").setErrors({ menorQueFinal: true });
          this.formulario.get("final").setErrors({ menorQueFinal: true });
          this.mensagem = "O valor inicial é igual ao final.";
          this.erro = true;

          this.condicaoResponse.emit({
            tipo: "valor",
            error: true,
          });

          return true;
        }

        this.condicaoResponse.emit({
          tipo: "valor",
          error: false,
          valor: {
            valorInicial: this.formulario.get("inicial").value,
            valorFinal: this.formulario.get("final").value,
          },
        });
      } else {
        this.condicaoResponse.emit({
          tipo: "valor",
          error: false,
          valor: {
            valorInicial: this.formulario.get("inicial").value,
            valorFinal: this.formulario.get("final").value,
          },
        });
      }
    }
  }
}
